import { render, staticRenderFns } from "./StatusSolicitacaoSelector.vue?vue&type=template&id=6f2c8743&scoped=true"
import script from "./StatusSolicitacaoSelector.vue?vue&type=script&lang=js"
export * from "./StatusSolicitacaoSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2c8743",
  null
  
)

export default component.exports